import { Link } from 'react-router-dom';
import TurkishMainLayout from '@/components/layout/TurkishMainLayout';
import { Button } from '@/components/ui/button';
import { CheckCircle } from 'lucide-react';

const TurkishContactSuccessPage = () => {
  return (
    <TurkishMainLayout>
      <div className="container mx-auto px-4 py-16">
        <div className="max-w-2xl mx-auto text-center">
          <div className="mb-8">
            <CheckCircle className="h-16 w-16 text-green-500 mx-auto" />
          </div>
          <h1 className="text-3xl font-bold text-hotel-primary mb-4">Bizimle İletişime Geçtiğiniz İçin Teşekkürler!</h1>
          <p className="text-gray-600 mb-8">
            Mesajınızı aldık ve 24 saat içinde size geri döneceğiz.
            Bu arada, Lobier hakkında daha fazla bilgi edinmekten ve otelinize nasıl yardımcı olabileceğimizi öğrenmekten çekinmeyin.
          </p>
          <Link to="/tr">
            <Button className="bg-hotel-primary hover:bg-hotel-primary/90">
              Ana Sayfaya Dön
            </Button>
          </Link>
        </div>
      </div>
    </TurkishMainLayout>
  );
};

export default TurkishContactSuccessPage; 